import React, {useState} from "react";
import {IoLogoWhatsapp} from "react-icons/io5";
import {Button, TextField} from "@mui/material";


export const LoginCalculadoraMacros = ({setLoginSuccessfull}) => {
    const [password, setPassword ] = useState('')
    const checkPassword = () =>
    {
        if (password === "vitaminas"){
            setLoginSuccessfull(true)
        }
    }
    return (

        <div className={'bg-whiteBG py-10 h-screen  px-5 flex items-center flex-col justify-center'}>

            {/* background gradient */}
            <div
                className='w-[70%]  rounded-xl  h-2/6 bg bg-contain bg-bottom flex flex-col items-center justify-end'
                id='gradient2'>
                {/* background image */}
                <div
                    className='w-full h-60 bg-contain bg-center bg-[url("/assets/WithLettersRaul3-mobile.png")] ] bg-no-repeat'
                    id='home'></div>
                {/*<a className={`w-[252px] h-9 p-3  text-md font-medium bg-sbPallet-accent rounded-lg flex items-center justify-center opacity-0 ${opacity} transition-opacity duration-1000 ease-in-out`} href="#">
                    Comienza tu cambio
                </a>*/}
            </div>
            {/* Call to action */}
            <div
                className={`flex md:px-8 justify-center xl:justify-center text-bgBlack   transition-all duration-1000 ease-out`}>
                <div className='md:w-[484px] pt-[10px]  mt-30 mb-[70px] flex flex-col justify-center'>
                    <h1 className='text-3xl md:text-5xl leading-8 font-black text-center mt-[18px]'><strong
                        className='text-sbPallet-accent'>Introduce la clave:</strong></h1>
                </div>

            </div>

            <input type={'password'} value={password} enterKeyHint={"send"} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    checkPassword();
                }
            }} onChange={v => setPassword(v.target.value)}
                   className="peer w-1/2 bg-black-10 placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-lg focus:shadow"
            />
            {/*boton rellenar formulario*/}
            <a className={`w-[212px] h-9 lg:w-[312px] lg:h-[52px] lg:my-10 lg:text-xl mb-10 transition-opacity duration-4000 p-3 mt-5
                 text-lg font-medium bg-sbPallet-accent rounded-lg flex items-center justify-center`} onClick={checkPassword}
            >Acceder</a>



        </div>
    )
}

